import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { ClientResolver, AgentResolver, CountriesResolver, LocalesResolver } from 'core/resolvers';
import { AgentsCacheResolver } from 'core/resolvers/agents-cache.resolver';
import { AgentsComponent } from './agents/agents.component';
import { AgentCreateComponent } from './agent-create/agent-create.component';
import { AgentDetailComponent } from './agent-detail/agent-detail.component';

export const agentsRoutes: Routes = [
  {
    path: 'agents',
    title: 'parentAgents',
    resolve: {
      countries: CountriesResolver,
      locales: LocalesResolver
    },
    children: [
      {
        path: '',
        title: 'agents',
        component: AgentsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'agents.list' }
      },
      {
        path: 'new',
        title: 'newAgent',
        component: AgentCreateComponent,
        resolve: {
          client: ClientResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'agents.create' }
      },
      {
        path: ':agentId',
        title: 'parentAgentId',
        resolve: {
          agentsCache: AgentsCacheResolver,
          agent: AgentResolver
        },
        children: [
          {
            path: '',
            title: 'agentIdDetail',
            component: AgentDetailComponent,
            resolve: {
              client: ClientResolver
            },
            canActivate: [ProfileGuard],
            data: { action: 'agents.detail', preloader: 'secondary' }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(agentsRoutes)],
  exports: [RouterModule]
})
export class AgentsRoutingModule {}
